import {Component, Input} from '@angular/core';
import {CitizensServices} from "../../../../../../store/entities/citizens/citizens-services/citizens-services.model";

@Component({
  selector: 'app-service-item',
  templateUrl: './service-item.component.html',
  styleUrl: './service-item.component.scss'
})
export class ServiceItemComponent {
  @Input() service: CitizensServices;
  @Input() userIsLoggedIn: boolean;

  getUrl() {
    const service = this.service?.serviceUniqueId;
    if (this.userIsLoggedIn) return '/tgsd-client/client-services/service-view/session/' + service;
    return '/service-view/' + service;
  }

}
